/**
 * Cookie工具类
 * 提供cookie的增删改查功能，过期时间设置为永久有效
 */

// 设置cookie，过期时间为永久有效（设置为最大日期）
export function setCookie(name, value, options = {}) {
  const defaultOptions = {
    expires: new Date('9999-12-31T23:59:59.999Z'), // 永久有效
    path: '/',
    secure: false,
    sameSite: 'Lax'
  }
  
  const finalOptions = { ...defaultOptions, ...options }
  
  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`
  
  if (finalOptions.expires) {
    cookieString += `; expires=${finalOptions.expires.toUTCString()}`
  }
  
  if (finalOptions.path) {
    cookieString += `; path=${finalOptions.path}`
  }
  
  if (finalOptions.domain) {
    cookieString += `; domain=${finalOptions.domain}`
  }
  
  if (finalOptions.secure) {
    cookieString += '; secure'
  }
  
  if (finalOptions.sameSite) {
    cookieString += `; samesite=${finalOptions.sameSite}`
  }
  
  document.cookie = cookieString
}

// 获取cookie
export function getCookie(name) {
  const nameEQ = encodeURIComponent(name) + '='
  const cookies = document.cookie.split(';')
  
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i]
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length)
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return decodeURIComponent(cookie.substring(nameEQ.length, cookie.length))
    }
  }
  return null
}

// 删除cookie
export function removeCookie(name, options = {}) {
  const defaultOptions = {
    path: '/',
    domain: options.domain || undefined
  }
  
  // 设置过期时间为过去的时间来删除cookie
  setCookie(name, '', {
    ...defaultOptions,
    ...options,
    expires: new Date(0)
  })
}

// 检查cookie是否存在
export function hasCookie(name) {
  return getCookie(name) !== null
}

// 获取所有cookie
export function getAllCookies() {
  const cookies = {}
  const cookieArray = document.cookie.split(';')
  
  for (let i = 0; i < cookieArray.length; i++) {
    const cookie = cookieArray[i].trim()
    if (cookie) {
      const [name, value] = cookie.split('=')
      if (name && value) {
        cookies[decodeURIComponent(name)] = decodeURIComponent(value)
      }
    }
  }
  
  return cookies
}

// 清除所有cookie
export function clearAllCookies() {
  const cookies = getAllCookies()
  Object.keys(cookies).forEach(name => {
    removeCookie(name)
  })
} 